/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Source_HelpInputs */



/**
* | output |
* | --- |
* | "Select the source type for your media import" |
*
* @param {Media_Import_Source_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_source_help = /** @type {((inputs?: Media_Import_Source_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Source_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionnez le type de source pour l'importation de votre media")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie den Quelltyp für Ihren Medienimport aus.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona il tipo di origine per l'importazione dei tuoi contenuti multimediali")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите тип источника для импорта медиафайлов.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione el tipo de fuente para su importación de medios")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择媒体导入的源类型")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディアインポートのソースタイプを選択します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपने मीडिया आयात के लिए स्रोत प्रकार का चयन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione o tipo de origem para a sua importação de mídia.")
	return /** @type {LocalizedString} */ ("Select the source type for your media import")
});